export const titleCodes = {
    
    contact: {
        code: "${merchantId}_tmpl_title_14",
        title: "Contact Us"
    },

    email: {
        code: "${merchantId}_tmpl_title_15",
        title: "Email:"
    },

    phone: {
        code: "${merchantId}_tmpl_title_16",
        title: "Phone Number:"
    },

    location: {
        code: "${merchantId}_tmpl_title_17",
        title: "Location:"
    },
}

export const textCodes = {
    
    emailText: {
        code: "${merchantId}_tmpl_text_13",
        text: "asteriamyanmar.mm@gmail.com"
    },

    phoneNumber: {
        code: "${merchantId}_tmpl_text_18",
        text: "099 7744 6464"
    },

    locationText: {
        code: "${merchantId}_tmpl_text_17",
        text: "Yangon, Myanmar"
    },

}
